import styled from 'styled-components';
import sharedStyles from '../styles';
import breakpoints from '../breakpoints';

const SortByBox = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoints.md}) {
    display: block;
    font-weight: ${sharedStyles.fontWeight.medium};
    margin-right: ${sharedStyles.spacing['spacing-md']};
  }
`;

export default SortByBox;
